<template>
  <div class="list-body" :class="{'show-menu':$store.showSideBar}" @contextmenu="onBucketRightClick">
    <side-bar></side-bar>

    <div class="list-body-container">

      <!-- 操作栏 -->
      <div class="tc-action-grid pb-16">
        <div class="justify-grid">
          <div class="col">
            <qc-button :disabled="disabledBtn.upload" type="default" size="short"
              @click="onEventAction({ action : 'uploadFiles'})">{{$t('core.upload')}}
            </qc-button>

            <span class="dropdown-button">
              <qc-button :disabled="disabledBtn.create" type="weak" size="short"
                @click="onEventAction({ action : 'createFolder'})">{{$t('core.create_folder')}}
              </qc-button>
              <span class="dropdown-dropdown">
                <qc-button class="dropdown-advance" :disabled="disabledBtn.create" type="weak" size="short"
                  @click="onEventAction({ action : 'createFile'})">{{$t('core.create_file')}}
                </qc-button>
              </span>
            </span>

            <qc-button :disabled="disabledBtn.download" type="weak" size="short"
              @click="onEventAction({ action : 'download'})">
              {{$t("core.download")}}</qc-button>
            <qc-dropdown type="button" trigger="hover" class="more-dropdown-menu">
              <template>
                {{$t('core.more')}}
              </template>
              <template slot="dropdown">
                <qc-dropdown-item @click="copyFiles" :disabled="disabledBtn.copy">
                  <span class="align-middle">{{$t('core.copy')}}</span>
                </qc-dropdown-item>
                <qc-dropdown-item @click="pasteFiles" :disabled="disabledBtn.paste">
                  <span class="align-middle">{{$t('core.paste')}}</span>
                </qc-dropdown-item>
                <!-- <qc-dropdown-item @click="onRestoreFilesShow" :disabled="!allowRestore">
                  <span class="align-middle">{{$t('core.restore')}}</span>
                </qc-dropdown-item> -->
                <qc-dropdown-item @click="dialogShow.delete = true" :disabled="disabledBtn.delete">
                  <span class="align-middle">{{$t('core.delete')}}</span>
                </qc-dropdown-item>
                <!-- <qc-dropdown-item @click="selectTargetAction='copy';selectTargetShow=true"
                  :disabled="selectedList.length===0">
                  <span class="align-middle">{{$t('core.copyTo')}}</span>
                </qc-dropdown-item>
                <qc-dropdown-item @click="selectTargetAction='move';selectTargetShow=true"
                  :disabled="selectedList.length===0">
                  <span class="align-middle">{{$t('core.moveTo')}}</span>
                </qc-dropdown-item> -->
              </template>
            </qc-dropdown>
            <qc-button type="weak" size="short" @click="toEditorMode">
              {{$t("core.editor_mode")}}</qc-button>
          </div>

          <div class="col">
            <!-- search start -->
            <qc-dropdown ref="searchType" class="search-dropdown" type="button" trigger="hover" :close-on-click="true">
              {{$t('core.searchType.' + searchTypeShowStr)}}
              <template slot="dropdown">
                <qc-dropdown-item @click="changeSearchType('prefix')">
                  {{$t('core.searchType.prefix')}}
                </qc-dropdown-item>
                <qc-dropdown-item @click="changeSearchType('fuzzy')">{{$t('core.searchType.fuzzy')}}
                </qc-dropdown-item>
              </template>
            </qc-dropdown>
            <div class="tc-15-search tc-15-multi-search" v-click-outside="onClickSearchInputOutside">
              <div class="search-input-wrap">
                <input class="tc-15-search-words" type="text" ref="searchInput" v-model="keyword"
                  @keyup.enter="handleSearch" @focus="onFocusSearchInput"
                  :placeholder="$t('core.search') + ' ' + (searchDir || Bucket || '')">
                <a v-if="keyword" href="#" role="button" class="btn-rm-txt" :title="$t('core.clear')"
                  @click="closeSearch">{{$t('core.clear')}}</a>

                <qc-bubble type="dark" :vertical-offset="-14">
                  <button class="tc-15-btn weak m search" :class="keyword ? 'search-btn-border':''"
                    @click="handleSearch"></button>
                  <template slot="popup">{{$t('core.search')}}</template>
                </qc-bubble>
              </div>
              <search-history :show="searchHistoryShow" :list.sync="searchHistoryList" @click="onClickSearchHistory"
                @update="updateSearchHistory">
              </search-history>
            </div>
            <!-- search end -->

            <!-- refresh -->
            <div class="ml-20 mr-20" style="display:inline-block;">
              <qc-bubble type="dark">
                <button type="button" class="tc-15-btn weak m refresh m-0"
                  @click="onRefresh">{{$t('core.refresh')}}</button>
                <template slot="popup">{{$t('core.refresh')}}</template>
              </qc-bubble>
            </div>

            <!-- switch grid/table start -->
            <ul class="switch-type disable-select">
              <div class="switch-type__item" @click="switchLayout('grid')">
                <qc-bubble type="dark">
                  <div class="cos-icon--16 grid" :class="{'active': $store.layout==='grid'}"></div>
                  <template slot="popup">{{$t('core.grid_layout')}}</template>
                </qc-bubble>
              </div>
              <div class="switch-type__item" @click="switchLayout('list')">
                <qc-bubble type="dark" placement="topRight">
                  <div class="cos-icon--16 list" :class="{'active': $store.layout==='list'}"></div>
                  <template slot="popup">{{$t('core.table_layout')}}</template>
                </qc-bubble>
              </div>
            </ul>
            <!-- switch grid/table end -->
          </div>
        </div>
      </div>

      <div class="tc-panel panel-Page">

        <div class="tc-action-grid search-bar" v-if="(isSearching || isSearchDone) && showSearchBar">
          <div class="justify-grid">
            <template>
              <div class="col">
                <span class="search-text" v-if="searchType === 'prefix'">{{$t('core.search_result[0]',
                  {result:list.length,keyword: lastGetListInfo.keyword})}}</span>
                <span class="search-text" v-else>{{$t('core.search_result[1]',
                  {num:searchedLength,
                  result: beyondSearchLimit ? searchLimitStr : list.length,
                  keyword: lastGetListInfo.keyword})}}</span>
                <qc-icon v-if="isSearching" :type="'loading'"></qc-icon>
              </div>
              <div class="col">
                <a v-if="isSearched && isSearching" href="javascript:;" class="cancel-search"
                  @click="cancelSearch">{{$t('core.cancel')}}</a>
                <a v-else href="javascript:;" class="cancel-search" @click="closeSearch">{{$t('core.close')}}</a>
              </div>
            </template>
          </div>
        </div>
        <div class="tc-action-grid search-bar sort-bar" v-if="(isSorting || isSortDone) && showSortBar">
          <div class="justify-grid">
            <template>
              <div class="col">
                <span class="search-text"
                  v-if="!beyondSortLimit && !isSortDone">{{$t('core.sort_result[0]',{result:list.length})}}</span>
                <span class="search-text"
                  v-else-if="!beyondSortLimit && isSortDone">{{$t('core.sort_result[1]',{result:list.length})}}</span>
                <span class="search-text"
                  v-else>{{$t('core.sort_result[2]',{result: Number(sortLimit).toLocaleString()})}}</span>
                <qc-icon v-if="isSorting" :type="'loading'"></qc-icon>
              </div>
              <div class="col">
                <a v-if="isSorted && isSorting" href="javascript:;" class="cancel-search"
                  @click="cancelSort">{{$t('core.cancel')}}</a>
                <a v-else href="javascript:;" class="cancel-search" @click="closeSort">{{$t('core.close')}}</a>
              </div>
            </template>
          </div>
        </div>

        <div class="list" v-if="$store.layout==='list'">
          <file-table ref="fileTable" :list.sync="list" :selected-list.sync="selectedList" :loading="loading"
            :search-status="{ isSearched, isSearching, isSearchDone, searchType, showSearchBar }"
            :sort-status="{ isSorting, isSorted, isSortDone, showSortBar}" :hasAuthority="hasAuthority"
            :pageSize="pageSize" :currPage="currPage" :allowCI="allowCIMap[Region]" :allowCAS="allowCASMap[Region]"
            @on-action="onEventAction" @on-show-key="showKeyInFolder" @on-sort-change="onSortChange"
            @on-scroll="dialogShow.contextMenu=false;">
            <template slot="footer">
              <pagination :total-num="beyondSearchLimit ? searchLimitStr : list.length"
                :selected-num="selectedList.length" :page-size="pageSize" :curr-page="currPage" :has-more="hasMore"
                @change="changePage">
              </pagination>
              <span style="display: none;"></span>
            </template>
          </file-table>
        </div>

        <div class="grid" v-else-if="$store.layout==='grid'" @contextmenu.prevent>
          <file-grid :list.sync="list" :selected-list.sync="selectedList" :loading="loading"
            :search-status="{ isSearched, isSearching, isSearchDone, searchType }" :is-searching="isSearching"
            :is-search-done="isSearchDone" :hasAuthority="hasAuthority" :pageSize="pageSize" :currPage="currPage"
            :allowCI="allowCIMap[Region]" :allowCAS="allowCASMap[Region]" @on-item-dblclick="openFiles"
            @on-action="onEventAction" @on-scroll="needThumbnail();dialogShow.contextMenu=false;">
            <template slot="footer">
              <pagination :total-num="this.list.length" :selected-num="selectedList.length" :page-size="pageSize"
                :curr-page="currPage" :has-more="hasMore" @change="changePage"></pagination>
            </template>
          </file-grid>
        </div>
      </div>
    </div>

    <file-info :show.sync="dialogShow.fileInfo" :selected-list="list" :file-item.sync="selectedList[0]"
      :bucket-info="{...bucketInfo,Prefix}" :allowCAS="allowCASMap[Region]" :allowDeepCAS="allowDeepCASMap[Region]"
      @copy-link-open="copyLinkOpen($event, 'showDialog')" @edit="onEditAcl(fileInfo)">
    </file-info>
    <!-- 图片/视频预览 -->
    <preview-file :show.sync="dialogShow.previewShow" @copy="copyLinkOpen($event,'fastCopy')"
      @download="onEventAction({ action : 'download'})"></preview-file>
    <rename-file :show.sync="dialogShow.renameFile" :bucket-info="{...bucketInfo,Prefix}" :rename-item="selectedList[0]"
      @refresh="onRenameFinish">
    </rename-file>
    <share-file ref="shareFile" :show.sync="dialogShow.shareFile" :share-link-info.sync="shareFileInfo"
      :bucket-info="{...bucketInfo,Prefix}"></share-file>
    <share-multiple :show.sync="dialogShow.shareMultiple" :selected-list="selectedList"
      :allowShare="allowUploadMap[Region]" @submit="handleShareMultiple">
    </share-multiple>
    <share-result :show.sync="dialogShow.shareResult" :share-multiple-info="shareMultipleInfo"></share-result>
    <advance-upload ref="advanceUpload" :show.sync="dialogShow.advanceUpload" :bucket-info="{...bucketInfo,Prefix}"
      :allowCAS="allowCASMap[Region]" :allowDeepCAS="allowDeepCASMap[Region]"></advance-upload>
    <delete-file :show.sync="dialogShow.delete" :list.sync="list" :selected-list="selectedList"
      :bucket-info="bucketInfo" :enableReplication="enableReplication" @fix-folder="fixFolder(Prefix)"
      @refresh="onRefresh">
    </delete-file>
    <create-dialog ref="create" :bucket-info="{...bucketInfo,Prefix}" @push-list="pushList($event.map(formatFileItem))"
      @refresh="onRefresh">
    </create-dialog>
    <paste-files :show.sync="dialogShow.pasteFiles" @submit="_pasteFiles"></paste-files>
    <!-- 各种操作失败表格展示 -->
    <failure-table :show.sync="dialogShow.failureTable"></failure-table>
    <multi-download :open-show.sync="dialogShow.openCosBrowser" :load-show.sync="dialogShow.loadCosBrowser"
      :reload-show.sync="dialogShow.reloadCosBrowser" :bucket-info="bucketInfo" :selected-list="selectedList">
    </multi-download>
    <monaco-editor :show.sync="dialogShow.editor" :file-info="editFileInfo" :bucket-info="{Bucket,Region}"
      @refresh="onRefresh">
    </monaco-editor>
    <context-menu :show.sync="dialogShow.contextMenu" :position="contextMenuPosition" menuType="bucket"
      @on-action="handleBucketEventAction"></context-menu>

    <bucketinfo-dialog ref="bucketInfo" :show.sync="dialogShow.bucketInfo" :bucket-info="bucketInfo"
                       @edit="handleEditBucket"></bucketinfo-dialog>
    <edit-image-slim :show.sync="dialogShow.editImageSlim" :bucket-info="bucketInfo" @submit="editBucketSubmit">
    </edit-image-slim>
    <!-- 区域选择器 -->
    <selector :layout="$store.layout"></selector>

    <div v-show="0">
      <!-- 下载使用 iframe -->
      <iframe id="downloadCosFile" src="" name="download" height="0" width="0"></iframe>
      <!-- 文件上传 -->
      <input ref="fileInput" type="file" multiple="multiple" @change="handleFileOrFolderInput($event, 'file')">
      <!-- 文件夹上传 -->
      <input ref="directoryInput" type="file" multiple="multiple" webkitdirectory="webkitdirectory"
        @change="handleFileOrFolderInput($event, 'folder')">
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import selector from 'components/common/selector.vue';
import pagination from 'components/common/pagination.vue';
import sideBar from 'components/common/sideBar.vue';
import contextMenu from 'components/common/contextMenu.vue';
import fileTable from 'components/desktop/fileTable.vue';
import fileGrid from 'components/desktop/fileGrid.vue';
import advanceUpload from 'components/dialog/file/advanceUpload.vue';
import deleteFile from 'components/dialog/file/deleteFile.vue';
import createDialog from 'components/dialog/file/createFileOrFolder.vue';
import failureTable from 'components/dialog/others/failureTable.vue';
import fileInfo from 'components/dialog/file/fileInfo.vue';
import shareFile from 'components/dialog/file/share/shareFile.vue';
import shareMultiple from 'components/dialog/file/share/shareMultiple.vue';
import shareResult from 'components/dialog/file/share/shareResult.vue';
import renameFile from 'components/dialog/file/renameFile.vue';
import previewFile from '@/components/dialog/file/previewFile.vue';
import pasteFiles from 'components/dialog/file/pasteFiles.vue';
import multiDownload from 'components/dialog/file/multiDownload.vue';
import MonacoEditor from 'components/dialog/file/editor/index.vue';
import bucketinfoDialog from 'components/dialog/bucket/bucketInfo.vue';
import editImageSlim from '@/components//dialog/bucket/editImageSlim.vue';
import SearchHistory from 'components/dialog/file/SearchHistory.vue';
import clickOutside from '@/scripts/directives/clickOutside';

import {
  tips,
  downloadUrl,
  formatSize,
  getFileIcon,
  formatTime,
  path as pathLib,
  isAllowPreviewImageKey,
  isAllowPreviewVideoKey,
  isAllowPreviewAudioKey,
} from '@/scripts/tools/utils';
import mta from '@/scripts/common/mta';
import cos from '@/scripts/helper/cos';
import eventProxy from '@/scripts/tools/eventProxy';
import DragSelection from '@/scripts/tools/DragSelection';
import { config, regions } from '@/scripts/tools/config';
import cosExpand from '@/scripts/helper/cos/cosExpand';
import * as cosSdkUtils from '@/scripts/helper/cos/cosSdkUtils';
import copyer from '@/scripts/helper/copyer';
import downloader from '@/scripts/helper/downloader';
import shareMultipleTools from '@/scripts/helper/shareMultipleTools';

export default {
  directives: {
    clickOutside,
  },
  components: {
    selector,
    sideBar,
    contextMenu,
    fileTable,
    fileGrid,
    pagination,
    advanceUpload,
    deleteFile,
    createDialog,
    failureTable,
    fileInfo,
    shareFile,
    shareMultiple,
    shareResult,
    renameFile,
    previewFile,
    pasteFiles,
    multiDownload,
    MonacoEditor,
    bucketinfoDialog,
    editImageSlim,
    SearchHistory,
  },
  data() {
    return {
      loading: false,
      list: [],
      selectedList: [],
      editKey: '',
      editFileInfo: {}, // 包含key和size的信息

      id: '',
      stoken: '',
      extract: '',
      shareInfo: {},

      Bucket: '',
      Region: '',
      Prefix: '',
      Marker: '',
      hasMore: false,
      hasAuthority: true,
      enableReplication: false,

      // 搜索框
      keyword: '',
      searchDir: '',
      searchTypeShowStr: 'prefix', // dropmenu 展示用
      searchType: 'prefix', // 真正搜索使用
      isSearching: false,
      isSearched: false,
      isSearchDone: false,
      searchedLength: 0,
      beyondSearchLimit: false,
      searchHistoryShow: false, // 是否显示历史记录框
      searchHistoryList: localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : [],

      // 排序
      isSorting: false,
      isSorted: false,
      isSortDone: false,
      sortLimit: config.sortLimit,
      beyondSortLimit: false,

      showSearchBar: false,
      showSortBar: false,
      listCacheFrom: '', // 列表是从模糊搜索缓存还是排序后缓存
      lastGetListInfo: {
        // 记录拉取列表是来自搜索（前缀还是模糊）还是排序
        from: '',
        searchType: '',
        keyword: '',
      },
      isRefreshing: false, // 是否点刷新

      // 分页器
      pageSize: 100,
      currPage: 1,
      allowPreview: false,
      // 缩略图
      allowCIMap: {}, // 支持万象地域
      allowCASMap: {}, // 支持归档存储地域
      allowDeepCASMap: {}, // 支持深度归档存储地域
      allowUploadMap: {}, // 支持文件上传地域
      showThumbnailBucket: '',
      showThumbnail: false,

      dialogShow: {
        fileInfo: false,
        advanceUpload: false,
        delete: false,
        create: false,
        failureTable: false,
        shareFile: false, // 单文件分享
        shareMultiple: false, // 多文件分享
        shareResult: false, // 多文件分享结果窗口
        previewShow: false, // 图片或视频预览播放
        pasteFiles: false,
        openCosBrowser: false, // 打开 COSBrowser 客户端弹窗
        loadCosBrowser: false, // 加载 COSBrowser 客户端弹窗
        reloadCosBrowser: false, //  重启 COSBrowser 客户端弹窗
        editor: false, // 文档编辑
        contextMenu: false, // 右键菜单：存储桶相关操作
        bucketInfo: false, // 存储桶详情
        editImageSlim: false, // 万象图片极智压缩
      },

      disabledBtn: {
        upload: true,
        download: true,
        delete: true,
        create: true,
        copy: true,
        restore: true,
        paste: true,
        edit: false,
        preview: false,
      },

      fileInfo: {}, // 文件详情信息
      bucketInfo: {}, // 存储桶详情信息
      shareFileInfo: {}, // 文件分享信息
      shareMultipleInfo: {}, // 多文件分享信息
      contextMenuPosition: {}, // 右键菜单：存储桶相关操作位置信息
    };
  },
  computed: {
    searchBarExist() {
      return this.isSearching || this.isSearchDone;
    },
    searchLimitStr() {
      return this.list.length === 0 ? 0 : `${config.searchLimit - 1}+`;
    },
    realKeyword() {
      return this.isRefreshing ? this.lastGetListInfo.keyword : this.keyword;
    },
    realSearchType() {
      return this.isRefreshing ? this.lastGetListInfo.searchType : this.searchType;
    },
    fileBody() {
      return this.$store.layout === 'grid' ? $('.grid-body') : $('.tc-15-table-fixed-body');
    },
  },
  watch: {
    // 监听路由变化
    $route() {
      this.handleRoute();
    },
    list() {
      this.selectedList = this.list.filter(v => v.checked);
    },
    selectedList(val) {
      this.selectionChange(val);
    },
    loading(val) {
      // breadCrumb 中的前进后退按钮需要在文件列表正在 loading 时禁用
      this.$store.fileLoading = val;
    },
    // 搜索框历史记录匹配
    keyword(val) {
      this.searchHistoryList = this.searchHistoryList.map(item => {
        item.show = item.value.toLowerCase().includes(val.toLowerCase());
        return item;
      });
      this.updateSearchHistory();
    },
    hasAuthority(val) {
      this.$store.showUserInfo = val;
    },
  },
  mounted() {
    if (!this.$store.isLogin) return;

    // 编辑文件弹框
    eventProxy.on('command.edit', this.onEditFile);

    eventProxy.on('upload-completed', this.onUploadFinish);
    eventProxy.on('command.copy', this.copyFiles);
    eventProxy.on('command.paste', this.pasteFiles);
    eventProxy.on('command.preview', this.onPreview);
    eventProxy.on('command.select-all', this.onSelectAll);
    // 拖选文件
    eventProxy.on('command.selector-start', this.selectorStart);
    eventProxy.on('command.selector-move', this.selectorMove);
    eventProxy.on('command.selector-end', this.selectorEnd);

    this.$nextTick(() => {
      this.handleRoute();
      const { fileBody, list } = this;
      // 拖选文件（在渲染结束后创建拖拽类实例）
      this.dragSelection = new DragSelection(fileBody, this.$store.layout, list);
      this.loading = true;
      // this.Bucket && this.checkMultipartList(); // 检查是否有文件碎片
      this.getRemoteConfig();
    });
    // 初始化显示所有历史搜索记录
    this.searchHistoryList = this.searchHistoryList.map(item => {
      item.show = true;
      return item;
    });
    this.updateSearchHistory();
    document.addEventListener('drop', this.dropEvent, false);
  },
  destroyed() {
    eventProxy.off('upload-completed', this.onUploadFinish);
    eventProxy.off('command.copy', this.copyFiles);
    eventProxy.off('command.paste', this.pasteFiles);
    eventProxy.off('command.preview', this.onPreview);
    eventProxy.off('command.select-all', this.onSelectAll);
    // 拖选文件
    eventProxy.off('command.selector-start', this.selectorStart);
    eventProxy.off('command.selector-move', this.selectorMove);
    eventProxy.off('command.selector-end', this.selectorEnd);
    this.dragSelection = null;
  },
  methods: {
    async handleRoute() {
      const { bucket, region, path = '' } = this.$route.query;
      this.Bucket = bucket;
      this.Region = region;
      const prefix = path.replace(/\/[^/]+$/, '/');
      this.Prefix = prefix;
      const bucketInfo = await cosExpand.getBucketInfo({
        Bucket: bucket,
        Region: region,
      });
      this.bucketInfo = { ...bucketInfo, Bucket: bucket, Region: region };
      this.resetFolder();
      if (path && !path.endsWith('/') && prefix !== path) {
        this.onEditFile({ bucket, region, key: path });
        this.$router.replace({ path: this.$route.path, query: { bucket, region, path: prefix } });
      }
    },
    // 初始化面包屑导航
    initCrumbs() {
      if (this.$store.crumbs.length === 1) {
        this.$store.crumbs.push({ name: this.Bucket, prefix: '/' });
      }
    },
    getRemoteConfig() {
      regions.forEach(item => {
        this.allowCIMap[item.region] = !item.disable_CI || false;
        this.allowCASMap[item.region] = !item.disable_CAS || false;
        this.allowDeepCASMap[item.region] = !item.disable_deep_CAS;
        this.allowUploadMap[item.region] = !item.disable_upload;
      });
    },
    dropEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dialogShow.advanceUpload = true;
      this.$refs.advanceUpload.handleDrop(e);
    },
    // 重置列表数据
    resetData() {
      this.list = [];
      this.selectedList = [];
      this.shareInfo = {};
      this.pageSize = 100;
      this.currPage = 1;

      const needInitBoolean = ['loading', 'hasMore'];
      needInitBoolean.forEach(key => {
        this[key] = false;
      });
      this.hasAuthority = true;

      const needInitString = ['extract', 'Bucket', 'Region', 'Prefix', 'Marker'];
      needInitString.forEach(key => {
        this[key] = '';
      });

      // 初始化所有弹窗展示
      Object.keys(this.dialogShow).forEach(key => {
        this.dialogShow[key] = false;
      });
      this.resetSearch();
    },
    // 切换视图
    switchLayout(layout) {
      this.$mutations.switchLayout(layout);
      if (layout === 'grid') {
        this.needThumbnail();
      }
    },
    toEditorMode() {
      const routeUrl = this.$router.resolve({
        name: 'editor',
        query: this.$route.query,
      });
      window.open(routeUrl.href, '_blank');
    },
    // 节流执行显示缩略图
    needThumbnail() {
      if (!this.showThumbnail) return;
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.onThumbnail();
        this.scrollTimer = 0;
      }, 100);
    },
    // 打开文件/文件夹 (右键/双击)
    openFiles(item) {
      if (item.isDir) {
        this.openFolder(item);
      } else if (this.allowPreview) {
        this.onPreview(item);
      } else {
        this.onEditFile(item);
      }
    },
    // 分页器改变
    changePage(page) {
      if (page.pageSize > this.pageSize || page.currPage > this.currPage) {
        if (!this.beyondSortLimit && this.hasMore) {
          this.pullList();
        }
      }
      this.currPage = page.currPage;
      this.pageSize = page.pageSize;
    },
    // 改变当前页展示要显示的文件
    changePage2ShowKey() {
      let keyIndex = -1;
      this.selectedList = this.list
        .filter((v, index) => {
          if (v.key === this.showKey) keyIndex = index;
          return v.key === this.showKey;
        })
        .forEach(v => {
          v.checked = true;
        });
      let currPage = keyIndex / this.pageSize;
      if (currPage < 0) {
        tips.error(this.$t('error.showkey_not_found'));
      } else {
        currPage = currPage === 0 ? 1 : currPage; // 处理要展示的文件索引为 0 的情况
        this.currPage = Math.ceil(currPage);
      }
    },
    // 拉取 cos 对象列表数据
    async pullList() {
      const self = this;
      if (!this.Marker) {
        this.list = [];
      }
      const { Bucket, Region } = this;
      if (!Bucket) {
        tips.error(window.lang.t('error.bucket_not_selected'));
        return;
      }
      this.loading = true;
      this.lastGetListInfo.from = 'search';
      this.lastGetListInfo.searchType = 'prefix';
      this.lastGetListInfo.keyword = this.realKeyword;
      // 若为前缀搜索且关键字不为空，则修改搜索状态
      if (this.realSearchType === 'prefix') {
        if (this.realKeyword) {
          this.isSearching = true;
          this.listCacheFrom = 'search';
        } else {
          // 空搜的结果不缓存
          this.listCacheFrom = '';
        }
      }
      cos.getBucket(
        {
          Bucket,
          Region,
          Prefix: this.Prefix + (this.realSearchType === 'prefix' ? this.realKeyword : ''),
          Marker: this.Marker,
          Delimiter: '/',
          MaxKeys: 1000,
        },
        (err, data) => {
          tips.closeTips();
          if (Bucket !== self.Bucket || Region !== self.Region) return;
          if (err) {
            const error = (err && err.error) || err;
            let errorMsg = '';
            if (error) {
              errorMsg = error.Code || error.code || error.Message || error;
            }
            tips.error(window.lang.err(`error['${errorMsg}']`, error));
            if (errorMsg === 'AccessDenied') self.hasAuthority = false;
            self.loading = false;
            // 若为前缀搜索且关键字不为空，则修改搜索状态
            if (this.realSearchType === 'prefix' && this.realKeyword) {
              this.isSearching = false;
            }
            return;
          }
          this.hasMore = data.IsTruncated === 'true';
          this.Marker = data.NextMarker;
          this.handleFileList(data);
          self.loading = false;
          // 若为前缀搜索且关键字不为空，则修改搜索状态
          if (this.realSearchType === 'prefix' && this.realKeyword) {
            this.isSearching = false;
            this.isSearched = true;
            this.isSearchDone = true;
          }
        },
      );
    },
    handleFileList(data) {
      this.hasMore = data.IsTruncated === 'true';
      this.Marker = data.NextMarker;
      const list = this.formatFileListData(data);
      if (this.realSearchType === 'prefix' && this.realKeyword) {
        this.list = [...this.list, ...list];
        this.arrangeList();
      } else {
        this.pushList(list);
      }
    },
    formatFileListData(data) {
      const list = [];
      if (data.CommonPrefixes && data.CommonPrefixes.length > 0) {
        const CommonPrefixes = data.CommonPrefixes.filter(v => v.Key !== this.Prefix); // 过滤出目录
        list.push(...CommonPrefixes.map(this.formatFileItem));
      }
      if (data.Contents && data.Contents.length > 0) {
        const Contents = data.Contents.filter(v => !v.Key.endsWith('/')); // 过滤出文件
        list.push(...Contents.map(this.formatFileItem));
      }
      return list;
    },
    // 增加文件/文件夹
    pushList(list) {
      let i = list.length;
      let item = {};
      let index = 0;
      let relKey = '';
      let dirKey = '';
      const deepMap = {};
      const deepItems = [];
      while (--i >= 0) {
        item = list[i];
        if (item.key.indexOf(this.Prefix) === 0) {
          relKey = item.key.substr(this.Prefix.length);
          if (item.isDir) {
            relKey = relKey.slice(0, -1);
          }
          index = relKey.indexOf('/');
          if (index > -1) {
            dirKey = `${this.Prefix + relKey.substr(0, index)}/`;
            if (!deepMap[dirKey]) {
              deepItems.push(this.formatFileItem({ Prefix: dirKey }));
              deepMap[dirKey] = true;
            }
            list.splice(i, 1);
          }
        } else {
          list.splice(i, 1);
        }
      }
      list.push(...deepItems);
      this.list.push(...list);
      this.arrangeList();
    },
    // 整理列表，去重，排序
    arrangeList() {
      // 从后往前去重
      let i = this.list.length;
      const hasNodeId = {};
      while (--i >= 0) {
        if (hasNodeId[this.list[i].key]) {
          this.list.splice(i, 1);
        }
        hasNodeId[this.list[i].key] = true;
      }
      // 排序
      this.sortList();

      if (this.showKey) {
        this.changePage2ShowKey();
        this.showKey = '';
      }
      // 显示缩略图
      this.needThumbnail();
      // if (this.$refs.table) {
      //   this.$refs.table.renderClientHeight();
      // }
    },
    // 排序
    sortList() {
      const { sortByTime, sortBySize } = this.$refs.fileTable
        ? this.$refs.fileTable.sortFields
        : { sortByTime: 'none', sortBySize: 'none' };
      if (sortByTime === 'none' && sortBySize === 'none') {
        // 按文件名排序
        this.list = this.list.sort((a, b) => {
          let com = 0;
          if (a.isDir !== b.isDir) {
            com = a.isDir ? -1 : 1;
          } else {
            com = a.name > b.name ? 1 : -1;
          }
          return com;
        });
      } else if (sortByTime !== 'none') {
        // 按时间排序
        this.list = this.list.sort((a, b) => {
          let com = 0;
          if (sortByTime === 'desc') {
            if (a.isDir !== b.isDir) {
              com = a.isDir ? 1 : -1;
            } else {
              com = a.mtime < b.mtime ? 1 : -1;
            }
          } else if (sortByTime === 'asc') {
            if (a.isDir !== b.isDir) {
              com = a.isDir ? -1 : 1;
            } else {
              com = a.mtime > b.mtime ? 1 : -1;
            }
          }
          return com;
        });
      } else if (sortBySize !== 'none') {
        // 按大小排序
        this.list = this.list.sort((a, b) => {
          let com = 0;
          if (sortBySize === 'desc') {
            if (a.isDir !== b.isDir) {
              com = a.isDir ? 1 : -1;
            } else {
              com = b.size - a.size;
            }
          } else if (sortBySize === 'asc') {
            if (a.isDir !== b.isDir) {
              com = a.isDir ? -1 : 1;
            } else {
              com = a.size - b.size;
            }
          }
          return com;
        });
      }
    },
    // 整理列表格式
    formatFileItem(item) {
      let o;
      if (item.Prefix) {
        let name = item.Prefix.slice(0, -1);
        name = name.substr(name.lastIndexOf('/') + 1);
        const _locates = item.Prefix.split('/');
        const len = _locates.length;
        o = {
          key: item.Prefix,
          name,
          isShared: this.shareMap && !!this.shareMap[item.Prefix],
          isDir: true,
          location: _locates.length > 2 ? _locates[len - 3] : this.Bucket, // 所在目录
          size: 0,
          sizeText: '',
          icon: 'document',
          mtime: '-',
          previewUrl: '',
          ETag: '',
          StorageClass: '',
        };
      } else {
        const _locates = item.Key.split('/');
        const len = _locates.length;
        o = {
          key: item.Key,
          name: item.Key.substr(item.Key.lastIndexOf('/') + 1),
          isDir: false,
          location: _locates.length > 1 ? _locates[len - 2] : this.Bucket, // 所在目录
          size: parseInt(item.Size, 10),
          sizeText: item.Size ? formatSize(item.Size, 2) : '-',
          icon: getFileIcon(item.Key),
          mtime: item.LastModified ? formatTime(item.LastModified) : '-',
          previewUrl: '',
          ETag: item.ETag,
          StorageClass: item.StorageClass,
        };
      }
      o.url = cos.getObjectUrl({
        Bucket: this.Bucket,
        Region: this.Region,
        Key: o.key,
        Sign: false,
      });
      o.itemClass = 'finder-item';
      o.checked = false;
      return o;
    },
    // 上传完成
    onUploadFinish(r) {
      if (!r.err) {
        const info = r.data;
        if (info.Bucket === this.Bucket && info.Region === this.Region) {
          const {
            Key, ETag, size, StorageClass,
          } = info;
          const item = this.formatFileItem({
            Key,
            ETag,
            Size: size,
            StorageClass,
          });
          this.pushList([item]);
        }
      }
    },
    // 表格/网格点击操作
    onEventAction({ action, item }) {
      switch (action) {
        case 'detail':
          this.openFileDetail(item);
          break;
        case 'download': {
          const singleFile = item || this.selectedList[0];
          if (this.selectedList.length === 1 && !singleFile.isDir) {
            this.onDownload(singleFile);
          } else {
            this.handleMultiDownload();
          }
          break;
        }
        case 'openFolderOrFile':
          this.openFolderOrFile(item);
          break;
        case 'delete':
          this.onDeleteFiles(item);
          break;
        case 'uploadFiles':
          if (this.allowUploadMap[this.Region]) {
            this.dialogShow.advanceUpload = true;
          } else {
            tips.error(this.$t('error.curr_region_not_support_operator'));
          }
          break;
        case 'createFile':
        case 'createFolder':
          if (this.allowUploadMap[this.Region]) {
            const funcName = `on${action.replace(/^c/, 'C')}`;
            this[funcName]();
          } else {
            tips.error(this.$t('error.curr_region_not_support_operator'));
          }
          break;
        case 'openFiles':
          this.openFiles(item);
          break;
        case 'share':
        case 'fastCopyLink':
          if (!item.isDir) {
            const type = action === 'share' ? 'showDialog' : 'fastCopy';
            this.copyLinkOpen(item, type);
          } else {
            // 多文件分享分享
            this.openShareMultiple(item);
          }
          break;
        case 'rename':
          this.onRename(item);
          break;
        case 'preview':
          this.onPreview(item);
          break;
        case 'copy':
          this.copyFiles(item);
          break;
        case 'paste':
          this.pasteFiles(item);
          break;
        case 'edit':
          this.onEditFile(item);
          break;
        default:
          break;
      }
    },
    // 打开文件夹 / 文件
    openFolderOrFile(item) {
      if (item.isDir) {
        this.openFolder(item);
        this.resetSearch();
      } else {
        this.openFileDetail(item);
      }
    },
    // 打开文件夹
    openFolder(item) {
      const query = {
        bucket: this.Bucket,
        region: this.Region,
        path: item.key,
      };
      if (!query.path) delete query.path;
      this.$router.push({ name: 'file', query }).catch(() => {});
    },
    // 打开文件详情
    openFileDetail(item) {
      if (item) {
        this.selectedList.forEach(m => {
          m.checked = false;
        });
        item.checked = true;
        this.selectedList = [item];
      }
      const file = item || this.selectedList[0];
      if (!file) return;
      this.dialogShow.fileInfo = true;
    },
    onCreateFolder() {
      eventProxy.emit('create.show', 'folder');
    },
    onCreateFile() {
      eventProxy.emit('create.show', 'file');
    },
    // 文件预览
    async onPreview(item) {
      const file = item || this.selectedList[0];
      if (!file) return;
      const { Bucket, Region } = this;
      // 归档类文件查看是否恢复
      if (file.StorageClass && file.StorageClass.includes('ARCHIVE')) {
        try {
          const isRestore = await cosExpand.getRestoreState({ Bucket, Region, Key: file.key });
          if (!isRestore) {
            tips.error(this.$t('error.archive_file_not_support_preview'));
            return;
          }
        } catch (err) {
          const { error } = err;
          const code = (error && (error.Code || error.code)) || err.code;
          tips.error(window.lang.err(`error['${code}']`, err));
          return;
        }
      }
      eventProxy.emit('preview.show'); // 打开预览窗口
      const { url } = file;
      let type;
      let filter;
      const filters = {
        image: isAllowPreviewImageKey,
        video: isAllowPreviewVideoKey,
        audio: isAllowPreviewAudioKey,
      };
      Object.keys(filters).some(t => {
        if (filters[t](file.key)) {
          filter = filters[t];
          type = t;
          return true;
        }
        return false;
      });
      if (type) {
        const previewList = this.list.filter(v => filter(v.key));
        eventProxy.emit('preview.show', { url, type, list: previewList });
      } else {
        tips.error(window.lang.t('error.not_support_to_preview'));
      }
    },
    // 编辑文件
    onEditFile(params) {
      // 根据判断是否有选中来判断是否来自console
      if (!this.selectedList[0]) {
        cos.headObject(
          {
            Bucket: params.bucket,
            Region: params.region,
            Key: params.key,
          },
          (headErr, headData) => {
            if (headErr) {
              if (headErr.error === 'Forbidden' && headErr.statusCode === 403) {
                tips.error(this.$t('error.no_permissions_to_head_object'));
              } else if (headErr.code === '404') {
                tips.error(`${params.key} Not Exist`);
              } else {
                tips.error(window.lang.err(`error['${headErr.error}']`, headErr));
              }
              return;
            }
            const tmpFileInfo = {
              key: params.key,
              size: '',
            };
            // 获取文件size
            const contentLength = headData && headData.headers && headData.headers['content-length'];
            tmpFileInfo.size = contentLength;
            this.editFileInfo = tmpFileInfo;
            this.dialogShow.editor = true;
          },
        );
      } else {
        this.editFileInfo = Object.assign(params);
        const item = this.selectedList[0];
        if (!item || item.isDir) return;
        this.dialogShow.editor = true;
      }
    },
    // 单个文件下载
    onDownload(item) {
      const { Bucket, Region } = this;
      const params = { Bucket, Region, Key: item.key };
      cosExpand
        .getObjectDownloadUrl(params)
        .then(async Url => {
          if (['DEEP_ARCHIVE', 'ARCHIVE'].includes(item.StorageClass)) {
            const restoreInfo = await cosExpand.getRestoreInfo(params);
            const storageText = this.$t(`cos.storage_class_map.${item.StorageClass}`);
            if (restoreInfo.status === 'restored') {
              downloadUrl(Url);
            } else if (restoreInfo.status === 'restoring') {
              tips.error(this.$t('state.fail.download_with_restoring', { storageText }));
            } else {
              tips.error(this.$t('state.fail.download_with_no_restore', { storageText }));
            }
          } else {
            downloadUrl(Url);
          }
        })
        .catch(err => {
          tips.error(err);
        });
    },
    handleMultiDownload() {
      const { Bucket, Region, selectedList } = this;
      this.dialogShow.openCosBrowser = false;
      this.dialogShow.reloadCosBrowser = false;
      // 检查用户是否打开了cosBrowser
      downloader.checkCosBrowserStatus(
        () => {
          // 已开启客户端
          this.dialogShow.loadCosBrowser = true;
          downloader
            .addDownloadTask({ Bucket, Region, selectedList })
            .then(() => {
              this.dialogShow.loadCosBrowser = false;
            })
            .catch(err => {
              this.dialogShow.loadCosBrowser = false;
              if (err === 'reload') {
                this.dialogShow.reloadCosBrowser = true;
              } else {
                tips.error(err.message || err);
              }
            });
        },
        () => {
          // 未开启客户端
          this.dialogShow.openCosBrowser = true;
        },
      );
    },
    onDeleteFiles(item) {
      if (item) {
        this.selectedList = [item];
      }
      const { Bucket, Region } = this;
      cosExpand.checkBucketReplication({ Bucket, Region }).then(data => {
        this.enableReplication = data;
        this.dialogShow.delete = true;
      });
    },
    // 删除文件夹内最后一个文件或者文件夹后，重新创建该文件夹
    fixFolder(path) {
      // 如果是最后一个文件（夹）
      if (!this.list.length && path !== '' && !this.hasMore) {
        // 创建当前文件夹
        this.$refs.create.onCreate(true);
      }
    },
    onRename(item) {
      if (item) {
        this.selectedList = [item];
      }
      const { Bucket, Region, Prefix } = this;
      const source = {
        Bucket,
        Region,
        Prefix,
        files: this.selectedList,
      };
      const target = { ...this.bucketInfo, Prefix };
      if (this.isSearched) {
        let realPrefix = pathLib.dirname(this.selectedList[0].key);
        realPrefix = realPrefix ? `${realPrefix}/` : realPrefix;
        [source.Prefix, target.Prefix] = [realPrefix, realPrefix];
      }
      eventProxy.emit('show.rename', { source, target, action: 'rename' });
    },
    // 重命名结束后根据情况进行列表的刷新
    onRenameFinish(item) {
      const { isSearched } = this;
      if (isSearched) {
        // 模糊搜索时保留搜索列表
        // 1. 移除原来的文件
        this.list = this.list.filter(o => o.key !== item.key);
        // 2.若新名字在搜索关键字中再将新名字放入列表里
        if (item.newKey.includes(this.realKeyword)) {
          item.key = item.newKey;
          item.name = item.key.substr(item.key.lastIndexOf('/') + 1);
          item.mtime = '-';
          this.list.push(item);
        }
      } else {
        this.onRefresh();
      }

      // 重命名结束后剪辑板为空，禁用粘贴
      this.disabledBtn.paste = true;
      eventProxy.emit('context-menu-option', this.disabledBtn);
    },
    // 打开多文件分享弹窗
    openShareMultiple(item) {
      if (item) {
        this.selectedList = [item];
      }
      const { Bucket, Region } = this;
      cosExpand.checkBucketReplication({ Bucket, Region }).then(data => {
        this.enableReplication = data;
        this.dialogShow.shareMultiple = true;
      });
    },
    // 多文件分享
    async handleShareMultiple({ DurationSeconds, extract, permission }) {
      const files = this.selectedList;
      if (!files.length) return;
      tips.loading(this.$t('core.loading'));
      const { Bucket, Region, Prefix } = this;
      try {
        const res = await shareMultipleTools.getShareLink({
          Bucket,
          Region,
          Prefix,
          files,
          DurationSeconds,
          extract,
          permission,
        });
        tips.closeTips();
        this.shareMultipleInfo = res;
        this.dialogShow.shareMultiple = false;
        this.dialogShow.shareResult = true;
      } catch (error) {
        tips.closeTips();
        tips.error(error);
      }
    },
    // 打开单文件复制链接弹窗
    async copyLinkOpen(item, type) {
      if (item) this.selectedList = [item];

      this.dialogShow.fileInfo = false;
      const file = item || this.selectedList[0];
      if (!file) return;

      let isPublic = '';

      const { Bucket, Region } = this;
      const { acl: bucketAcl } = this.bucketInfo;
      const params = {
        Bucket,
        Region,
        bucketAcl,
        Key: file.key,
      };

      const handleInfo = acl => {
        this.shareFileInfo = {
          name: file.name,
          key: file.key,
          acl,
          type: isPublic ? 'unSign' : 'sign',
          url: file.url,
        };
        // 文件列表 icon 是快速复制链接
        // 文件详情里的“创建临时链接”是弹窗复制链接
        // 其他根据是否公有读判断
        if (type === 'fastCopy') {
          this.shareFileInfo.tag = 'fastCopy';
          this.$refs.shareFile.doShareLink(this.shareFileInfo);
        }
      };

      if (type !== 'fastCopy') {
        this.dialogShow.shareFile = true;
        handleInfo('loading');
      } else {
        tips.loading(window.lang.t('cos.loading_file_acl'));
      }

      // 设定 3 秒 获取真实 acl 请求超时时间
      setTimeout(() => {
        if (isPublic === '') {
          tips.closeTips();
          tips.error(this.$t('error.loading_file_acl_timeout'));
          isPublic = false;
          if (type === 'fastCopy') {
            type = 'showDialog';
            this.dialogShow.shareFile = true;
          }
          handleInfo('unknown-with-timeout');
        }
      }, 3000);

      const realACL = await cosExpand.getObjectRealAcl(params);

      tips.closeTips();
      if (isPublic !== '') return;
      isPublic = cosSdkUtils.isPublic(realACL);
      handleInfo(realACL);
    },
    // 复制文件/文件夹
    copyFiles(list) {
      list = list && list.length ? list : this.selectedList;
      const copyCount = list.length;
      if (copyCount) {
        const source = {
          ...this.bucketInfo,
          Prefix: this.Prefix,
          files: list,
        };
        copyer.copy(source, () => {
          tips.closeTips();
          tips.success(window.lang.t('cos.copy_files.msg', { count: copyCount }));
        });
        this.disabledBtn.paste = false;
        eventProxy.emit('context-menu-option', this.disabledBtn);
        navigator.clipboard.writeText('');
      }
    },
    /**
     * 粘贴文件/文件夹，弹出确认弹窗
     */
    async pasteFiles(opt) {
      const e = window.event;
      const clip = e && e.clipboardData;
      if (clip && clip.files && clip.files.length) {
        this.uploadPasteFiles({ files: clip.files, paste: true });
        copyer.clipboard = null;
      } else if (copyer.clipboard) {
        const source = copyer.clipboard;
        let target = { ...this.bucketInfo, Prefix: this.Prefix };
        let action = 'copy';
        if (opt && ['copy', 'move'].includes(opt.action)) {
          ({ target, action } = opt);
        }

        if (source.files.length === 1 && !source.files[0].isDir) {
          eventProxy.emit('show.rename', { source, target, action });
        } else {
          const { sameNameList, code } = await copyer.getSameNameList(source, target);
          if (code) {
            tips.error(this.$t(`error.${code}`));
          } else if (sameNameList) {
            if (!sameNameList.length) {
              this._pasteFiles({ target, action });
            } else {
              eventProxy.emit('show.pasteFiles', {
                source,
                target,
                action,
                sameNameList,
              });
            }
          }
        }
      } else {
        tips.error(this.$t('error.no_file_to_paste'));
      }
    },
    // 复制粘贴 | 复制移动文件/文件夹，真正粘贴
    _pasteFiles(opt) {
      const { target, action } = opt;
      tips.loading(
        this.$t('core.state_map.doing[0]', {
          action: this.$t(`core.${action}`),
        }),
      );
      if (action === 'copy') {
        target.allowSituCopy = true; // 允许原地复制粘贴
      }
      target.onProgress = info => {
        const combineText = `${this.$t(`core.${action}`)} (${info.fileLoaded}/${info.fileTotal})，${info.Key} (${
          Math.round(info.percent * 10000) / 100
        }%)`;
        tips.loading(this.$t('core.state_map.doing[0]', { action: combineText }));
      };
      target.action = action;

      copyer[`${action}To`](target, (err, data) => {
        if (data) {
          if (data.successList.length) {
            tips.success(
              this.$t(`state.success.${action}_files`, {
                count: data.successList.length,
              }),
            );
          }
          setTimeout(() => {
            this.onRefresh();
          }, 500);
        }

        // 移动| 粘贴结束后剪辑板为空，禁用粘贴按钮
        if (action === 'move') {
          this.disabledBtn.paste = true;
          eventProxy.emit('context-menu-option', this.disabledBtn);
        }
      });
    },
    /**
     * 搜索功能
     * */
    changeSearchType(searchType) {
      this.searchTypeShowStr = searchType;
    },
    onSearch(isRefreshing) {
      // 区分点搜索和点刷新按钮
      this.isRefreshing = typeof isRefreshing === 'boolean' ? isRefreshing : false;
      if (!this.realKeyword) {
        tips.error(this.$t('core.keyword_empty'));
        return;
      }
      this.addSearchHistory(this.keyword);
      this.searchType = this.searchTypeShowStr;
      mta.clickStat('search', { searchtype: this.realSearchType });

      // 中断排序
      if (this.isSorting) {
        this.cancelSort();
      }
      this.list = [];
      this.Marker = '';
      this.currPage = 1;
      [this.showSearchBar, this.showSortBar] = [true, false];
      this.lastGetListInfo.from = 'search';

      if (!this.realKeyword || this.realSearchType === 'prefix') {
        this.lastGetListInfo.searchType = 'prefix';
        this.pullList();
        return;
      }

      const self = this;

      [this.loading, this.isSearching, this.isSearched] = [true, true, false];
      this.hasMore = false;
      this.searchedLength = 0;
      this.beyondSearchLimit = false;
      this.listCacheFrom = 'search';
      this.lastGetListInfo.searchType = 'fuzzy';
      this.lastGetListInfo.keyword = this.realKeyword;

      // 取消之前的搜索迭代
      let canceled = false;
      eventProxy.emit('cancel-last-search');

      const { Bucket, Region } = this;
      const keyword = this.realKeyword;
      let params = { Bucket, Region, MaxKeys: 1000 };
      const list = [];
      const dirMap = {};

      const next = (Prefix, Marker) => {
        if (canceled) return;
        // 监听是否取消本次搜索事件
        eventProxy.once('cancel-last-search', () => {
          self.listCacheFrom = 'search';
          canceled = true;
        });

        params = { ...params, Prefix, Marker };
        cos.getBucket(params, (err, data) => {
          if (Bucket !== self.Bucket || Region !== self.Region) return;
          if (err) {
            let error = (err && err.error) || err;
            if (error) {
              error = error.Code || error.code || error.Message;
            }
            tips.error(window.lang.err(`error['${error}']`), error);
            self.loading = false;
            self.isSearching = false;
            return;
          }
          if (self.isSearching && data && !canceled) {
            if (data.Contents && data.Contents.length) {
              let Dirs = [];
              const Contents = data.Contents.filter(item => {
                self.searchedLength++;

                // 忽略前缀表示的文件（or文件夹）
                if (item.Key === data.Prefix) return false;

                // 搜到的 key 是真实目录
                if (item.Key.slice(-1) === '/') {
                  const keys = item.Key.split('/');
                  keys.length -= 1;
                  let i = 0;
                  for (; i < keys.length; i++) {
                    if (keys[i].includes(keyword)) {
                      const index = i;
                      const dir = keys
                        .slice(0, index + 1)
                        .map(key => `${key}/`)
                        .join('');
                      if (dir !== data.Prefix && !dirMap[dir]) {
                        dirMap[dir] = true;
                      }
                    }
                  }
                  return false;
                }
                // 搜到的 key 非真实目录
                const keys = item.Key.split('/');
                let i = 0;
                for (; i < keys.length; i++) {
                  if (keys[i].includes(keyword)) {
                    if (i !== keys.length - 1) {
                      // 虚拟目录
                      const index = i;
                      const dir = keys
                        .slice(0, index + 1)
                        .map(key => `${key}/`)
                        .join('');
                      if (dir !== data.Prefix && !dirMap[dir]) {
                        dirMap[dir] = true;
                      }
                    }
                    // 文件
                    return keys[i].includes(keyword);
                  }
                }
                return false;
              });
              Dirs = Object.keys(dirMap).map(item => ({ Prefix: item }));
              list.push(...Dirs.map(self.formatFileItem));
              list.push(...Contents.map(self.formatFileItem));
            }
            if (list.length) {
              self.isSearched = true;
              self.list = [...self.list, ...list];
              self.arrangeList();
            }
            if (data.IsTruncated === 'true' && self.list.length < config.searchLimit) {
              self.beyondSearchLimit = false;
              self.loading = false;
              next(data.Prefix, data.NextMarker);
            } else {
              // 当检索出的数据达到searchLimit就停止拉取数据
              if (self.list.length >= config.searchLimit) {
                self.beyondSearchLimit = true;
                self.list.splice(config.searchLimit, self.list.length - config.searchLimit);
              }
              [self.hasMore, self.loading] = [false, false];
              [self.isSearching, self.isSearched, self.isSearchDone] = [false, true, true];
              self.listCacheFrom = 'search';
            }
          }
        });
      };
      next(this.Prefix, this.Marker);
    },
    handleSearch() {
      this.$refs.searchInput.blur();
      this.searchHistoryShow = false;
      this.onSearch();
    },
    // 监听搜索输入框的聚焦事件
    onFocusSearchInput() {
      this.searchHistoryShow = true;
    },
    // 监听搜索输入框外部的点击事件
    onClickSearchInputOutside() {
      this.searchHistoryShow = false;
    },
    // 监听历史搜索记录的点击事件
    onClickSearchHistory(searchVal) {
      this.keyword = searchVal;
      this.searchHistoryShow = false;
      this.onSearch();
    },
    // 添加历史搜索记录(如果历史记录中存在当前要添加的记录，则将当前要添加的记录置于首位)
    addSearchHistory(val) {
      this.searchHistoryList = this.searchHistoryList.filter(item => item.value !== val);
      this.searchHistoryList.unshift({ value: val, show: true });
      this.updateSearchHistory();
    },
    // 更新本地缓存中的历史搜索记录
    updateSearchHistory() {
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistoryList));
    },

    // 关闭搜索：直接清除刷新
    closeSearch() {
      this.resetSortStatus();
      this.resetSearch();
      this.resetFolder();
      this.listCacheFrom = '';
    },
    // 取消搜索：保留已搜索到的列表，仅停止搜索
    cancelSearch() {
      this.isSearchDone = true;
      this.isSearching = false;
      eventProxy.emit('cancel-last-search');
    },
    // 重置搜索状态
    resetSearch() {
      // 清空搜索状态
      this.isSearching = false;
      this.isSearched = false;
      this.isSearchDone = false;
      this.keyword = '';
      this.showSearchBar = false;
    },
    // 清空且重置
    resetFolder() {
      // 清空搜索状态
      this.isSearching = false;
      this.isSearched = false;
      this.isSearchDone = false;
      const lastDir = this.Prefix.replace(/^.*?([^/]+)\/?$/, '$1');
      this.searchDir = lastDir ? `${lastDir}/` : '';
      this.beyondSearchLimit = false;

      // 清空排序状态
      this.resetSort();

      // 重置列表数据
      this.list = [];
      this.Marker = '';
      this.hasMore = false;
      this.currPage = 1;

      this.lastGetListInfo.from = 'search';
      this.lastGetListInfo.searchType = 'prefix';
      this.lastGetListInfo.keyword = '';
      this.isRefreshing = false;

      this.pullList();
    },

    // 刷新界面
    onRefresh() {
      // 重置列表数据
      this.list = [];
      this.Marker = '';
      this.hasMore = false;
      this.currPage = 1;
      this.isRefreshing = true;

      if (this.lastGetListInfo.from === 'sort') {
        this.onSort();
      } else {
        if (this.lastGetListInfo.searchType === 'prefix') {
          // 上一次搜索是前缀搜索
          this.pullList();
          return;
        }
        this.onSearch(true);
      }
    },

    // 在文件夹中展示搜索到的 key
    showKeyInFolder(item) {
      this.resetSearch();
      const { key, isDir } = item;
      let prefix = key.substr(0, key.lastIndexOf('/')).replace(/^\//, '').replace(/\/$/, '');
      if (isDir) {
        // 如果是目录，则前缀中去掉他本身
        prefix = prefix.substr(0, prefix.lastIndexOf('/')).replace(/^\//, '').replace(/\/$/, '');
      }

      if (prefix) {
        const query = {
          bucket: this.Bucket,
          region: this.Region,
          path: `${prefix}/`,
        };
        if (!query.path) delete query.path;
        this.$router.push({ name: 'file', query }).catch(() => {});
      } else {
        this.resetFolder();
      }
      this.showKey = key;
    },

    // 排序
    onSort() {
      const self = this;
      const { Bucket, Region } = this;
      if (!Bucket) {
        tips.error(window.lang.t('error.bucket_not_selected'));
        return;
      }
      this.list = [];
      this.loading = true;
      this.isSorted = false;
      this.hasMore = false;
      this.beyondSortLimit = false;
      this.showSearchBar = false;
      this.showSortBar = true;
      this.isSorting = true;
      this.isRefreshing = false;
      self.lastGetListInfo.from = 'sort';

      // 取消之前的排序
      let canceled = false;
      eventProxy.emit('cancel-last-sort');
      let marker = '';
      const next = (Prefix, Marker) => {
        if (canceled) return;
        // 监听是否取消本次搜索事件
        eventProxy.once('cancel-last-sort', () => {
          self.listCacheFrom = 'sort';
          canceled = true;
        });

        cos.getBucket(
          {
            Bucket,
            Region,
            Prefix,
            Marker,
            Delimiter: '/',
            MaxKeys: 1000,
          },
          (err, data) => {
            tips.closeTips();
            if (Bucket !== self.Bucket || Region !== self.Region) return;
            if (err) {
              const error = (err && err.error) || err;
              let errorMsg = '';
              if (error) {
                errorMsg = error.Code || error.code || error.Message || error;
              }
              tips.error(window.lang.err(`error['${errorMsg}']`, error));
              if (errorMsg === 'AccessDenied') self.hasAuthority = false;
              self.loading = false;
              return;
            }

            if (self.isSorting && data && !canceled) {
              self.hasMore = data.IsTruncated === 'true';
              marker = data.NextMarker;
              self.handleFileList(data);
              self.loading = false;
              if (data.IsTruncated === 'true' && self.list.length < config.sortLimit) {
                self.loading = false;
                self.isSorted = true;
                self.beyondSortLimit = false;
                next(data.Prefix, marker);
              } else {
                // 当检索出的数据达到sortLimit就停止拉取数据
                if (self.list.length >= config.sortLimit) {
                  self.beyondSortLimit = true;
                  self.list.splice(config.sortLimit, self.list.length - config.sortLimit);
                }
                self.hasMore = false;
                self.loading = false;
                self.isSorting = false;
                self.isSorted = true;
                self.isSortDone = true;
                self.listCacheFrom = 'sort';
              }
            }
          },
        );
      };

      const prefix = this.Prefix + (this.realSearchType === 'prefix' ? this.realKeyword : '');
      next(prefix, marker);
    },
    /**
     * 监听排序态改变
     */
    onSortChange(sortBy) {
      // 是否显示排序提示bar
      if (this.listCacheFrom === 'search') {
        this.showSortBar = false;
      } else {
        this.showSortBar = Boolean(sortBy !== 'none');
      }
      if (this.listCacheFrom) {
        // 从缓存排序
        this.sortList();
        if (sortBy === 'none') {
          // 回归none的下一次排序需要重新拉取
          this.listCacheFrom = '';
        }
      } else {
        this.onSort();
      }
    },
    cancelSort() {
      this.isSortDone = true;
      this.isSorted = true;
      this.isSorting = false;
      eventProxy.emit('cancel-last-sort');
    },
    closeSort() {
      this.resetSort();
      this.resetFolder();
      this.showSortBar = false;
      this.isSortDone = true;
    },
    resetSortStatus() {
      this.listCacheFrom = '';
      this.lastGetListInfo.from = '';
      if (this.$refs.fileTable) {
        this.$refs.fileTable.resetSortStatus();
      }
      this.sortList();
    },
    resetSort() {
      this.isSortDone = false;
      this.isSorting = false;
      this.isSorted = false;
      this.resetSortStatus();
    },
    // 获取当前页渲染的 list
    getCurrRenderList() {
      // 筛选出总列表
      const totalList = this.list;
      // 计算总大小和当前页码
      const totalNum = totalList.length;
      // 找出当前显示的列表
      const start = (this.currPage - 1) * this.pageSize;
      const end = Math.min(totalNum, start + this.pageSize);
      const pageList = totalList.slice(start, end);
      return pageList || [];
    },
    // 拖拽选区开始
    selectorStart(data) {
      if (this.dragSelection) {
        const { fileBody } = this;
        // console.log('selectorStart -> fileBody', fileBody);
        const { layout } = this.$store;
        const currRenderList = this.getCurrRenderList();
        this.dragSelection.refresh(fileBody, layout, currRenderList);
        this.dragSelection.selectorStart(data);
        this.selectedList = this.dragSelection.selectedList;
      }
    },
    // 拖拽选区移动
    isSameList(l1, l2) {
      return l1.map(v => v.key).join(',') === l2.map(v => v.key).join(',');
    },
    // 拖拽选区移动
    selectorMove(data) {
      if (this.dragSelection) {
        this.dragSelection.selectorMove(data);
        if (!this.isSameList(this.dragSelection.selectedList, this.selectedList)) {
          this.selectedList = this.dragSelection.selectedList;
        }
      }
    },
    // 拖拽选区结束
    selectorEnd(data) {
      if (this.dragSelection) {
        this.dragSelection.selectorEnd(data);
        this.selectedList = this.dragSelection.selectedList;
      }
    },
    // 选项改变
    selectionChange(selectedList) {
      const first = selectedList[0];
      const listEmpty = selectedList.length === 0;
      const isSingle = selectedList.length === 1;
      const isSingleFile = selectedList.length === 1 && !selectedList[0].isDir;
      const isSingleDir = selectedList.length === 1 && selectedList[0].isDir;
      const isArc = first && ['ARCHIVE', 'DEEP_ARCHIVE'].includes(first.StorageClass);

      let previewType = '';
      if (selectedList.length === 1) {
        if (isAllowPreviewImageKey(first.key)) {
          previewType = 'image';
        } else if (isAllowPreviewVideoKey(first.key)) {
          previewType = 'video';
        } else if (isAllowPreviewAudioKey(first.key)) {
          previewType = 'audio';
        }
      }
      this.allowPreview = !!previewType;
      Object.assign(this.disabledBtn, {
        upload: !this.Bucket || this.searchBarExist,
        download: listEmpty,
        delete: listEmpty,
        create: this.searchBarExist,
        copy: listEmpty || this.searchBarExist,
        // restore: listEmpty || !this.allowCASMap[this.Region], // 判断是否允许归档取回(多选)
        open: !isSingleFile,
        detail: !isSingleFile,
        rename: !isSingleFile || isArc,
        share: !isSingle || isArc,
        preview: !this.allowPreview, // 预览
        previewType,
        edit: isSingleDir || !isSingle || this.allowPreview,
        uploadAndCreate: true,
      });
      eventProxy.emit('context-menu-option', this.disabledBtn);
    },
    // 非列表项右键菜单
    onBucketRightClick(e) {
      const $target = $(e.target);
      const $parents = $target.parents().add($target);
      // 当非弹窗 | 非输入框时，阻止浏览器默认行为并打开自定义右键菜单
      if (
        e.target.tagName !== 'INPUT'
        && e.target.tagName !== 'BUTTON'
        && e.target.tagName !== 'TEXTAREA'
        && !$parents.hasClass('dialog__mask')
        && !$parents.hasClass('dialog-box')
      ) {
        this.dialogShow.contextMenu = true;
        this.contextMenuPosition = { x: e.clientX, y: e.clientY };
        e.preventDefault();
      }
    },
    editBucketSubmit({ type, params }) {
      if (params) {
        if (type === 'acl') {
          this.bucketInfo.acl = params;
        } else if (type === 'versioning') {
          this.bucketInfo.versioning = params;
        } else if (type === 'imageSlim') {
          this.bucketInfo.imageSlim = params;
        } else if (type === 'acceleration') {
          this.bucketInfo.acceleration = params;
          this.$store.acceleration[this.bucketInfo.Bucket] = params;
        } else if (type === 'intelligentTiering') {
          this.bucketInfo.intelligentTiering = params;
        }
      }
    },
    handleEditBucket({ type, item }) {
      if (type === 'acl') {
        this.onEditBucketAcl(item);
      } else if (type === 'versioning') {
        this.onEditBucketVersioning(item);
      } else if (type === 'imageSlim') {
        this.onEditImageSlim(item);
      }
      // else if (type === 'acceleration') {
      //   this.onEditBucketAcceleration(item);
      // } else if (type === 'intelligentTiering') {
      //   this.onEditBucketIntelligentTiering(item);
      // }
    },
    async onEditImageSlim(item) {
      if (item.imageSlim) {
        this.dialogShow.editImageSlim = true;
        return;
      }
      if (this.bucketInfo.OFSConfig === 'OFS') {
        tips.error(this.$t('error.ofs_image_slim_unsupport'));
        return;
      }
      const imageSlim = await cosExpand.getBucketImageSlim(item);
      if (imageSlim === 'AccessDenied') {
        tips.error(this.$t('error.get_access_denied'));
      } else if (imageSlim === 'Unknown') {
        tips.error(this.$t('error.UNKNOWN'));
      } else if (imageSlim === 'RegionUnsupport') {
        tips.error(this.$t('error.region_image_slim_unsupport'));
      } else if (imageSlim === 'UpsAppNotExist') {
        tips.error(this.$t('error.ups_app_not_exist'));
      } else {
        Object.assign(this.bucketInfo, item);
        this.dialogShow.editImageSlim = true;
        this.bucketInfo.imageSlim = imageSlim;
      }
    },
    // 处理存储桶相关操作
    handleBucketEventAction(action) {
      switch (action) {
        case 'bucketInfo': {
          this.dialogShow.bucketInfo = true;
          break;
        }
        case 'uploadFile':
        case 'uploadFolder': {
          if (this.allowUploadMap[this.Region]) {
            const inputElStr = action === 'uploadFile' ? 'fileInput' : 'directoryInput';
            this.$refs[inputElStr].click();
          } else {
            tips.error(this.$t('error.curr_region_not_support_operator'));
          }
          break;
        }
        case 'refresh': {
          this.onRefresh();
          break;
        }
        default: {
          this.onEventAction({ action });
          break;
        }
      }
    },
    // 处理文件/文件夹上传
    handleFileOrFolderInput(e, type) {
      const inputElStr = type === 'file' ? 'fileInput' : 'directoryInput';
      const component = this.$refs.advanceUpload;
      component.initData();
      component.handleFileInput(e, this.$refs[inputElStr]);
      if (component.disableBtn) return;
      component.onSubmit();
    },
    /**
     * 文件全选
     */
    onSelectAll() {
      this.list = this.list.map(item => {
        item.checked = true;
        return item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// hack 英语语言包 展示
.i18n-en {
  .more-dropdown-menu {
    ::v-deep .tc-15-dropdown-menu {
      max-width: 140px;
    }
  }
}

.more-dropdown-menu {
  margin-left: 0 !important;
  margin-right: 8px;
}

.search-bar.tc-action-grid {
  padding: 0;
  background-color: #d6e8ff;
  .justify-grid {
    height: 28px;
    .col {
      font-size: 12px;
      color: #08090a;
      .search-text {
        margin-left: 20px;
      }
      .cancel-search {
        margin-right: 20px;
      }
    }
  }
}

.search-dropdown {
  background-color: transparent;
  ::v-deep a {
    border: 0;
  }
}

// 搜索输入框的搜索按钮换位置
.tc-action-grid .col {
  .tc-15-search {
    .tc-15-btn.search {
      left: initial;
      right: 1px;
      &.search-btn-border {
        border-left: 1px solid #c7cfd9;
      }
    }
    .search-input-wrap {
      .tc-15-search-words {
        padding-left: 8px;
      }
      .btn-rm-txt {
        right: 35px;
      }
    }
  }
}
</style>
